import { GetThunkAPI } from '@reduxjs/toolkit/dist/createAsyncThunk'
import { MaybePromise } from '@reduxjs/toolkit/dist/query/tsHelpers'
import {
  fetchSectionSettings,
  IFetchSectionSettingsParameters,
} from 'legacy/lut/services/partner360/sectionSettings/fetchSectionSettings'
import { createAsyncThunk } from 'legacy/lut/store/utils/createAsyncThunk'
import { compose } from 'redux'

import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'

import { REQUEST_SECTION_SETTINGS } from '../constants'

interface IRequestSectionSettingsParameters
  extends Omit<IFetchSectionSettingsParameters, 'ownerId'> {}

export const requestSectionSettings = createAsyncThunk<any, IRequestSectionSettingsParameters>(
  REQUEST_SECTION_SETTINGS,
  async ({ partnerId, fYear }, { getState }) => {
    const ownerId = compose(selectAppOwnerId, getState)()
    const response = await fetchSectionSettings({ partnerId, fYear, ownerId })

    return response
  },
  {
    condition: ({ fYear, partnerId }) => {
      if (!fYear || !partnerId) {
        return false
      }

      return
    },
  }
)
